/**
 * 横軸の固定列の既定の幅（固定する列・幅は利用者が列の設定で変えられる。#3690）
 */
export const LEFT_FIXED_COLUMN_WIDTH = {
  STATUS: 160,
  BUNDLE_LABEL: 140,
  ORDER_NO: 190,
  SHIPPING_DATE: 100,
  DELIVERY_DATE: 100
} as const satisfies Record<string, number>
